module.exports = __webpack_public_path__ + "static/media/lighthouseVaLogo.1dc26d71.png";